/*
 * ==========================================================================
 * SingRank - Lead + CTA tracker for kgteknik.co.id              v1.1.0
 * --------------------------------------------------------------------------
 * v1.1.0 (2026-10-05) - "tracker v2" for KG: this file becomes the ONLY lead
 * tracker on the site. Until now a second, older tracker
 * (snippets/singrank-tracking.liquid, rendered by the "SingRank tracking"
 * custom-liquid block in sections/footer-group.json, guard __SR_GEO_LEAD__)
 * ran next to this one with a DIFFERENT guard, so both listened:
 *   - every form submit was written twice in the same second (one row with
 *     first_page from this file, one without from the old snippet);
 *   - the old snippet matched [id*="whatsapp"] and [data-wa], which hit the
 *     floating "Mari Bicara!" widget wrapper (id kgwa-...__whatsapp_freBy7)
 *     and the article popup root (#sr-kg-pop data-wa), so EVERY click inside
 *     them (open button, each input, close, submit) wrote a bare
 *     "WhatsApp click" row with no first_page.
 * That snippet is retired in the same patch. To keep the floating widget
 * measured, this file now records it explicitly:
 *   6. Widget opened          "Mari Bicara!" button, ONCE per page view,
 *                             message "WhatsApp widget opened" (an intent
 *                             signal, NOT a WhatsApp conversation - filter it
 *                             out when counting real leads)
 *   7. Widget form sent       the widget's own form (opens wa.me via
 *                             window.open), only when the form is valid,
 *                             message "WhatsApp form — ..." incl. city/province
 * Also: invalid forms are no longer recorded (the widget form is novalidate,
 * so the submit event fired even when the browser then refused it), and the
 * same form cannot be recorded twice within 3 s.
 * WHY THIS FILE OWNS EVERYTHING HERE
 * Theme "SingRank x KG-Tenik" (159001280661) carried NO tracker at all when
 * this was written (2026-09-01: zero hits for leads.rumah.live in
 * layout/theme.liquid). On ablink and RCS the WhatsApp half already belonged
 * to an older widget, so the new file had to skip it; here there is nothing
 * to collide with, so this ONE file records the complete set:
 *
 *   1. WhatsApp clicks        wa.me / api.whatsapp / whatsapp: links
 *   2. Contact form submits   name / phone / email / website / message
 *   3. Phone taps             tel: links
 *   4. Email taps             mailto: links
 *   5. Outbound CTA clicks    hosts in OUTBOUND_HOSTS (rajawangi.co.id -
 *                             the sister company; a click across is a real
 *                             intent signal for the group)
 *
 * Everything carries first-touch attribution (first_page, first_referrer,
 * first_ts) plus the last Google Ads click id, so a lead can be credited to
 * the page that BROUGHT the visitor, not just where they finally acted.
 *
 * THE ARTICLE POPUP AND DOUBLE-COUNTING
 * sections/singrank-article-popup.liquid sends a rich lead itself via
 * window.SR_LEAD.track() and then opens WhatsApp. Before opening it sets
 * window.__SR_SKIP_NEXT_WA__ = true; the WhatsApp capture below consumes that
 * flag and stays silent ONCE, so the popup's own WA open is never counted a
 * second time. Same pattern ablink uses (_skipWaOpen).
 *
 * SLUG IS HARD-CODED "kgteknik" - matches the existing 18-row bucket and
 * CLIENT_ALIASES. Never derive it from location.hostname.
 *
 * FIELD NAMES: the server stores exactly client, name, phone, email, website,
 * message, wa_number, page, title, referrer, gclid, first_page,
 * first_referrer, first_ts. Anything else is dropped silently.
 *
 * CONTENT TYPE IS text/plain AND MUST STAY THAT WAY - application/json
 * triggers a CORS preflight sendBeacon cannot perform; the row dies silently.
 *
 * SAFETY
 * - Never blocks, delays or rewrites a click or submit. Fire and forget.
 * - Skips search boxes and newsletter-only forms.
 * - 1.2s same-target debounce absorbs duplicate click events.
 * - Guarded by window.__SR_LEAD_TRACKER__; a second copy is a no-op.
 * - try/catch throughout; no regular expressions, by house rule.
 *
 * DEBUG
 *   window.SR_LEAD.state()  slug, first-touch, last payload sent
 *   window.SR_LEAD.test()   send a TEST-DELETE row, for verification
 *
 * Maintained by SingRank. Created 2026-09-01.
 * ==========================================================================
 */
(function () {
  'use strict';

  if (window.__SR_LEAD_TRACKER__) { return; }
  window.__SR_LEAD_TRACKER__ = true;

  var ENDPOINT = 'https://leads.rumah.live/track';
  var SLUG = 'kgteknik';

  var OUTBOUND_HOSTS = ['rajawangi.co.id'];
  var WHATSAPP_MARKERS = ['wa.me', 'whatsapp.com', 'whatsapp:'];

  // The footer "Mari Bicara!" widget (sections/whatsapp.liquid). Its open
  // button carries data-kgwa-open; its form id starts with "kgwa-form-".
  var WIDGET_OPEN_ATTR = 'data-kgwa-open';
  var WIDGET_FORM_PREFIX = 'kgwa-form-';
  var TRACK_WIDGET_OPEN = true;   // set false to stop recording widget opens

  var STATE = { slug: SLUG, first: null, gclid: '', lastSent: null, count: 0, widgetOpenSent: false };
  var lastClick = { key: '', at: 0 };

  function low(s) { return String(s == null ? '' : s).toLowerCase(); }

  function contains(haystack, needles) {
    var h = low(haystack);
    if (!h) { return false; }
    for (var i = 0; i < needles.length; i++) {
      if (h.indexOf(needles[i]) > -1) { return true; }
    }
    return false;
  }

  function param(name) {
    try {
      var q = window.location.search || '';
      if (!q) { return ''; }
      var parts = q.substring(1).split('&');
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (eq < 0) { continue; }
        if (decodeURIComponent(parts[i].substring(0, eq)).toLowerCase() === name) {
          return decodeURIComponent(parts[i].substring(eq + 1).split('+').join(' '));
        }
      }
    } catch (e) {}
    return '';
  }

  function firstTouch() {
    try {
      var key = '__sr_ft_' + SLUG;
      var mine = window.localStorage.getItem(key);
      if (mine) {
        var m = JSON.parse(mine);
        if (m && m.p) { return m; }
      }
      var fresh = {
        p: window.location.href,
        r: document.referrer || '',
        t: new Date().toISOString()
      };
      window.localStorage.setItem(key, JSON.stringify(fresh));
      return fresh;
    } catch (e) {}
    return { p: window.location.href, r: document.referrer || '', t: '' };
  }

  function adClickId() {
    try {
      var key = '__sr_g_' + SLUG;
      var found = param('gclid') || param('wbraid') || param('gbraid');
      if (found) { window.localStorage.setItem(key, found); return found; }
      return window.localStorage.getItem(key) || '';
    } catch (e) {}
    return param('gclid') || '';
  }

  STATE.first = firstTouch();
  STATE.gclid = adClickId();

  function send(payload) {
    try {
      payload.client   = SLUG;
      payload.page     = window.location.href;
      payload.title    = document.title || '';
      payload.referrer = document.referrer || '';
      payload.ts       = new Date().toISOString();

      if (STATE.gclid) { payload.gclid = STATE.gclid; }
      if (STATE.first && STATE.first.p) {
        payload.first_page     = STATE.first.p;
        payload.first_referrer = STATE.first.r || '';
        payload.first_ts       = STATE.first.t || '';
      }

      var body = JSON.stringify(payload);
      var blob = new Blob([body], { type: 'text/plain' });

      STATE.lastSent = payload;
      STATE.count = STATE.count + 1;

      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) { return true; }

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        keepalive: true,
        mode: 'no-cors'
      });
      return true;
    } catch (e) { return false; }
  }

  function read(form, selector) {
    try {
      var el = form.querySelector(selector);
      return el ? String(el.value || '').trim() : '';
    } catch (e) { return ''; }
  }

  // ---------- contact form submits ----------
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!f || f.tagName !== 'FORM') { return; }
      // The article popup handles its own send; skip its form here.
      if (f.id === 'sr-kg-pop-form') { return; }
      // A form the browser / widget will refuse is not a lead.
      if (f.checkValidity && !f.checkValidity()) { return; }
      // Same form twice within 3 s = one lead (double tap, double listener).
      if (!onceFor('form|' + (f.id || f.action || ''), 3000)) { return; }

      var fid = String(f.id || '');
      if (fid.indexOf(WIDGET_FORM_PREFIX) === 0) {
        var wName  = read(f, '[name="name"]');
        var wEmail = read(f, '[name="email"]');
        var wCity  = read(f, '[name="city"]');
        var wProv  = read(f, '[name="province"]');
        var wMsg   = read(f, '[name="message"]');
        send({
          name: wName,
          email: wEmail,
          message: 'WhatsApp form — ' + (wCity ? wCity : '-') + ', ' + (wProv ? wProv : '-') + ' — ' + wMsg
        });
        return;
      }

      var email = read(f, '[type="email"],[name*="email" i],[name="contact[email]"]');
      var phone = read(f, '[type="tel"],[name*="phone" i],[name*="tel" i]');
      var msg   = read(f, 'textarea,[name*="message" i],[name*="body" i],[name="contact[body]"]');
      var name  = read(f, '[name*="name" i],[name="contact[name]"],[autocomplete="name"]');
      var web   = read(f, '[type="url"],[name*="website" i],[autocomplete="url"]');

      if (!email && !phone && !msg) { return; }

      send({
        name: name,
        phone: phone,
        email: email,
        website: web,
        message: msg || 'Form submit'
      });
    } catch (e) {}
  }, true);

  // ---------- clicks: WhatsApp / phone / email / outbound ----------
  function linkHost(href) {
    try { return low(new URL(href, window.location.href).hostname); }
    catch (e) { return ''; }
  }

  function waNumberFrom(href) {
    var s = href;
    var probes = ['wa.me/', 'phone='];
    for (var i = 0; i < probes.length; i++) {
      var at = s.indexOf(probes[i]);
      if (at < 0) { continue; }
      var rest = s.substring(at + probes[i].length);
      var num = '';
      for (var j = 0; j < rest.length; j++) {
        var c = rest.charAt(j);
        if (c >= '0' && c <= '9') { num += c; }
        else if (c === '+' && num === '') { continue; }
        else { break; }
      }
      if (num.length >= 6) { return num; }
    }
    return '';
  }

  function once(key) {
    var now = new Date().getTime();
    if (key === lastClick.key && (now - lastClick.at) < 1200) { return false; }
    lastClick.key = key;
    lastClick.at = now;
    return true;
  }

  var lastByKey = {};
  function onceFor(key, ms) {
    var now = new Date().getTime();
    if (lastByKey[key] && (now - lastByKey[key]) < ms) { return false; }
    lastByKey[key] = now;
    return true;
  }

  document.addEventListener('click', function (ev) {
    try {
      // Floating "Mari Bicara!" widget: record the OPEN once per page view.
      // It is a <button>, not a link, so it never reaches the link logic.
      if (TRACK_WIDGET_OPEN && !STATE.widgetOpenSent && ev.target && ev.target.closest) {
        var opener = ev.target.closest('[' + WIDGET_OPEN_ATTR + ']');
        if (opener) {
          STATE.widgetOpenSent = true;
          send({ message: 'WhatsApp widget opened' });
          return;
        }
      }

      var a = (ev.target && ev.target.closest) ? ev.target.closest('a[href]') : null;
      if (!a) { return; }

      var href = a.getAttribute('href') || '';
      if (!href) { return; }
      var h = low(href);
      var label = String(a.textContent || '').split('\n').join(' ').trim().substring(0, 60);

      if (contains(h, WHATSAPP_MARKERS)) {
        if (window.__SR_SKIP_NEXT_WA__) { window.__SR_SKIP_NEXT_WA__ = false; return; }
        if (!once('wa|' + h)) { return; }
        send({
          wa_number: waNumberFrom(href),
          message: 'WhatsApp click' + (label ? ' — ' + label : '')
        });
        return;
      }

      if (h.indexOf('tel:') === 0) {
        if (!once('tel|' + h)) { return; }
        send({ phone: href.substring(4).trim(), message: 'Phone click' });
        return;
      }

      if (h.indexOf('mailto:') === 0) {
        if (!once('mail|' + h)) { return; }
        send({ email: href.substring(7).split('?')[0].trim(), message: 'Email click' });
        return;
      }

      var target = linkHost(href);
      if (!target) { return; }
      for (var i = 0; i < OUTBOUND_HOSTS.length; i++) {
        if (target.indexOf(OUTBOUND_HOSTS[i]) > -1) {
          if (!once('out|' + h)) { return; }
          send({
            website: href.substring(0, 290),
            message: 'Outbound click: ' + OUTBOUND_HOSTS[i] + (label ? ' - ' + label : '')
          });
          return;
        }
      }
    } catch (e) {}
  }, true);

  window.SR_LEAD = {
    version: '1.1.0',
    slug: SLUG,
    track: send,
    state: function () { return STATE; },
    test: function () {
      return send({
        name: 'TEST-DELETE',
        phone: '0000',
        email: 'test@delete.me',
        message: 'TEST-DELETE'
      });
    }
  };
})();
